// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XcBiGfIEWkTmTSqkzFcF{flex-direction:column;gap:8px;width:492px;padding:40px 0 24px;display:flex}.fZTMdhX8_eIXj5dDFexD{margin-top:24px}.pJoWJlCFH4jdc8dDn0sH{margin-top:24px;padding-bottom:22px}.bysvNg6bRYAiUXpjJH8U{flex-flow:column wrap;gap:8px;display:flex}.b_o4X0Vedxs6CmtVOvcu{border:1px solid var(--border-neutral-default);border-radius:6px;align-items:center;width:-webkit-fit-content;width:fit-content;margin-bottom:4px;padding:3px 8px;display:flex}.b_o4X0Vedxs6CmtVOvcu:last-of-type{margin-bottom:10px}.sKaEbgYZrP0NVjF9vw_K{align-items:center;display:flex}.czL1F0or3KI96_6q6ZAH{background:var(--content-neutral-primary);border-radius:50%;width:2px;height:2px;margin:0 8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `XcBiGfIEWkTmTSqkzFcF`,
	"addButton": `fZTMdhX8_eIXj5dDFexD`,
	"list": `pJoWJlCFH4jdc8dDn0sH`,
	"items": `bysvNg6bRYAiUXpjJH8U`,
	"item": `b_o4X0Vedxs6CmtVOvcu`,
	"numberDescription": `sKaEbgYZrP0NVjF9vw_K`,
	"dot": `czL1F0or3KI96_6q6ZAH`
};
export default ___CSS_LOADER_EXPORT___;
